import { select } from '@ps/web-core-store';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

const useAuthenticatedContent = <T = unknown>(content?: T, loggedInContent?: T): T => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);

  if (isAuthenticated && !isEmpty(loggedInContent)) {
    return loggedInContent as T;
  }

  return content as T;
};

export default useAuthenticatedContent;
